import { useMutation } from "@tanstack/react-query";
import { updateBloomreachFieldMappings } from "../../api/bBloomreachApi";

export const useUpdateBloomreachFieldMappings = () => {
  return useMutation({
    mutationKey: ["update-bloomreach-field-mappings"],
    mutationFn: (data) => updateBloomreachFieldMappings(data),
  });
};
